import { useAtomValue } from 'jotai';

import { userLocaleAtom } from 'common/state/localeState';

export const useUserLocale = () => {
  return useAtomValue(userLocaleAtom);
};
